import { z } from "zod";

export const calculatorEmailSchema = z.object({
  emailAddress: z.string().email("A valid email is required"),
});
export type CalculatorEmailFormData = z.infer<typeof calculatorEmailSchema>;
